import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { RichTextEditor } from '~components'
import { Input } from '~stories'

import styles from '../FAQPageSections/FAQAdminFields.module.css'

const { Text } = Typography

const FAQAttendingFields = ({ attending, onFieldChange }) => {
  const { title = '', description = '', disclaimer = '', cta = {} } = attending || {}

  return (
    <div className={styles.fieldGroup}>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Title</Text>
        <Input
          onChange={e => onFieldChange('title', e.target.value)}
          placeholder="Attending an Event?"
          value={title}
        />
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Description</Text>
        <RichTextEditor
          minHeight={160}
          onChange={html => onFieldChange('description', html)}
          placeholder="Write description content…"
          value={description}
        />
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Disclaimer</Text>
        <RichTextEditor
          minHeight={120}
          onChange={html => onFieldChange('disclaimer', html)}
          placeholder="Write disclaimer content…"
          value={disclaimer}
        />
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>CTA Label</Text>
        <Input
          onChange={e => onFieldChange('cta_label', e.target.value)}
          placeholder="View Calendar"
          value={cta?.label || ''}
        />
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>CTA Link</Text>
        <Input
          onChange={e => onFieldChange('cta_href', e.target.value)}
          placeholder="/calendar"
          value={cta?.href || ''}
        />
        <Text className={styles.hint}>Relative path (e.g. /calendar) or full URL.</Text>
      </div>
    </div>
  )
}

FAQAttendingFields.propTypes = {
  attending: PropTypes.object,
  onFieldChange: PropTypes.func.isRequired
}

export default FAQAttendingFields
